import { faAdd } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@rocketlane/ui';
import { FormattedMessage } from 'react-intl';

export const Header = ({
  showResourceModal,
}: {
  showResourceModal: (value: boolean) => void;
}) => (
  <div className="flex w-full p-4">
    <div className="heading-compact-01 flex flex-1">
      <FormattedMessage id="settings.integrations.sf.resource_mappings.title" />
    </div>
    <Button
      onClick={() => showResourceModal(true)}
      rightIcon={<FontAwesomeIcon icon={faAdd} />}
      variant="primary"
      data-cy="integrations.salesforce_object_add"
    >
      <FormattedMessage id="settings.integrations.sf.resource_mappings.add" />
    </Button>
  </div>
);
